<template>
  <div>
    <base-tip-tap-editor ref="editor" @update="updateContent" />
    <v-btn outlined color="primary" class="mt-4" @click="insertDefaultContent">
      <v-icon left>mdi-plus</v-icon>
      Chèn nội dung mẫu
    </v-btn>
  </div>
</template>

<script>
import BaseTipTapEditor from '@/components/basic/BaseTipTapEditor.vue'

export default {
  components: {
    BaseTipTapEditor
  },

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  methods: {
    insertDefaultContent() {
      const defaultContent = `
        <div style="font-family: Arial, sans-serif; padding: 20px;">
          <h2 style="color: #2196F3; text-align: left; margin-bottom: 20px;">BÁO CÁO HỌC TẬP</h2>

          <div style="margin-bottom: 20px;">
            <p><strong>Họ và tên học sinh:</strong> {Tên học sinh}</p>
            <p><strong>Ngày học:</strong> {Ngày}</p>
            <p><strong>Thời gian:</strong> {Giờ học}</p>
            <p><strong>Lớp:</strong> {Tên lớp}</p>
            <p><strong>Giáo viên phụ trách:</strong> {Tên giáo viên}</p>
          </div>

          <div style="margin-bottom: 20px;">
            <h3 style="color: #2196F3;">ĐÁNH GIÁ CHI TIẾT</h3>
            {Tiêu chí đánh giá}
          </div>

          <div>
            <h3 style="color: #2196F3;">GHI CHÚ</h3>
            <p>{Nội dung ghi chú}</p>
          </div>
        </div>
      `
      
      this.$refs.editor.editor.commands.setContent(defaultContent)
      this.$emit('input', defaultContent)
    },

    updateContent() {
      const content = this.$refs.editor.editor.getHTML()
      this.$emit('input', content)
    }
  }
}
</script>
